import { EventAggregator } from 'aurelia';
import { inject } from 'aurelia';

import { CamelCaseValueConverter } from '../resources/value-converters/camel-case';

import { ApiService } from './api-service';
import { SessionService } from './session-service';

@inject(ApiService, SessionService, EventAggregator, CamelCaseValueConverter)
export class IpAddressService {
    path = 'IpAddress';

    constructor(private api: ApiService, private sessionService: SessionService, private eventAggregator: EventAggregator, private camelCaseValueConverter: CamelCaseValueConverter) {}

    async postIp() {
        try {
            const response = await this.api.doPost(this.path, {});
            this.eventAggregator.publish('vpn-detection', { vpn: response.vpn, tor: response.tor, ip: response.ip });
            await this.saveUserProxy(response);
            await this.saveGeoLocation(response);
            return response;
        } catch (error) {
            console.error('Error fetching IP data:', error);
            return null;
        }
    }

    async getIpData() {
        try {
            const response = await this.api.doGet(`${this.path}/GetIpData`);
            if (response) await this.saveGeoLocation(response);
            return response;
        } catch (error) {
            console.error('Error fetching IP data:', error);
            return null;
        }
    }

    async saveGeoLocation(geolocation) {
        if (geolocation) {
            this.sessionService.geolocation = geolocation;
            this.eventAggregator.publish('geolocation-updated', { geolocation });
        }
    }

    async saveUserProxy(userProxy) {
        this.sessionService.userProxy = userProxy;
    }
}
